import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { AnalysisLoadingView } from "./analysis/AnalysisLoadingView";
import { useExploreImage } from "./ExploreImageContext";
import { RegionSelectionView } from "./region-selection/RegionSelectionView";
import { ResultsView } from "./results/ResultsView";

interface ExploreImageFlowProps {
  onFlowStepChange?: (step: string) => void;
  onScrollToNav?: () => void;
}

export const ExploreImageFlow = ({
  onFlowStepChange,
  onScrollToNav,
}: ExploreImageFlowProps) => {
  const { state, discard } = useExploreImage();
  const location = useLocation();
  const locationKeyRef = useRef(location.key);

  useEffect(() => {
    if (locationKeyRef.current !== location.key) {
      locationKeyRef.current = location.key;
      if (state.flowStep !== "idle") {
        discard();
      }
    }
  }, [location.key, state.flowStep, discard]);

  const prevFlowStepRef = useRef<string | null>(null);
  useEffect(() => {
    return () => {
      prevFlowStepRef.current = null;
    };
  }, []);
  useEffect(() => {
    const prev = prevFlowStepRef.current;
    prevFlowStepRef.current = state.flowStep;

    if (prev !== null && prev !== state.flowStep) {
      onFlowStepChange?.(state.flowStep);

      if (
        state.flowStep === "region-selection" ||
        state.flowStep === "analysis" ||
        state.flowStep === "results"
      ) {
        window.scrollTo(0, 0);
      }

      if (state.flowStep === "idle" && prev !== "idle") {
        onScrollToNav?.();
      }
    }
  }, [state.flowStep, onFlowStepChange, onScrollToNav]);

  if (state.flowStep === "region-selection") {
    return <RegionSelectionView />;
  }

  if (state.flowStep === "analysis") {
    return <AnalysisLoadingView />;
  }

  if (state.flowStep === "results") {
    return <ResultsView />;
  }

  return null;
};
